import React from 'react';
import { AlertTriangle, Bell, XCircle, CheckCircle } from 'lucide-react';
import { Card, CardContent } from '../../../components/ui/card';
import BackButton from '../../../components/admin/BackButton';

const AssistantAlerts = () => {
  const alerts = [
    {
      title: "Overdue Invoice",
      message: "Invoice #1234 is 15 days overdue",
      severity: "high",
      icon: XCircle,
      color: "text-red-600",
      bgColor: "bg-red-100"
    },
    {
      title: "Low Stock Alert",
      message: "Product XYZ inventory is below threshold",
      severity: "medium",
      icon: AlertTriangle,
      color: "text-yellow-600",
      bgColor: "bg-yellow-100"
    },
    {
      title: "System Update Available",
      message: "New platform update ready to install",
      severity: "low",
      icon: CheckCircle,
      color: "text-blue-600",
      bgColor: "bg-blue-100"
    }
  ];

  return (
    <div>
      <BackButton />
      
      <div className="mb-8">
        <div className="flex items-center space-x-3">
          <div className="p-3 bg-red-500 bg-opacity-10 rounded-lg">
            <Bell className="h-6 w-6 text-red-600" />
          </div>
          <div>
            <h2 className="text-2xl font-bold text-[#2B2D42]">Alerts & Notifications</h2>
            <p className="text-sm text-[#6C757D]">Important alerts and smart notifications</p>
          </div>
        </div>
      </div>

      <div className="space-y-4">
        {alerts.map((alert, index) => {
          const Icon = alert.icon;
          return (
            <Card key={index}>
              <CardContent className="pt-6">
                <div className="flex items-start space-x-4">
                  <div className={`${alert.bgColor} p-3 rounded-lg`}>
                    <Icon className={`h-6 w-6 ${alert.color}`} />
                  </div>
                  <div className="flex-1">
                    <div className="flex items-start justify-between">
                      <div>
                        <h3 className="font-semibold text-[#2B2D42] mb-1">{alert.title}</h3>
                        <p className="text-sm text-[#6C757D]">{alert.message}</p>
                      </div>
                      <span
                        className={`px-2 py-1 text-xs rounded-full ${
                          alert.severity === 'high'
                            ? 'bg-red-100 text-red-800'
                            : alert.severity === 'medium'
                            ? 'bg-yellow-100 text-yellow-800'
                            : 'bg-blue-100 text-blue-800'
                        }`}
                      >
                        {alert.severity}
                      </span>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>

      <Card className="mt-8 bg-red-50 border-red-200">
        <CardContent className="pt-6">
          <p className="text-sm text-[#6C757D]">
            🔔 <strong>Smart Alerts</strong> will notify you of important events and anomalies in real-time. 
            This feature is under development.
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default AssistantAlerts;